import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate, Outlet } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { formDataHelper } from "../../../util/helpers";
import "./Login.css";
import CardLayout from "../../common/cardLayout/CardLayout";
import LoginImage from "../../../assets/images/login-image.png";
import AdultLogoDark from "../../../assets/images/rosesvglogo.svg";
import YouthLogoDark from "../../../assets/images/youth_logo_dark.png";
import eyeopen from "../../../assets/icons/eye-open.svg";
import eyeclose from "../../../assets/icons/EyeClose.svg";
import { Helmet } from "../../common/Helmet";
import { sendOtpLogic } from "../../../store/features/app/appSlice";
import { notify } from "../../../util/helpers";
import "./../../../../src/index.css";
import AdultLoginLogo from "../../../assets/images/Precise_Digital_adult_login_Logo.svg";
import YouthLoginLogo from "../../../assets/images/Precise_Digiatl_youth_Login_ Logo.svg";

const COOLDOWN_KEY = "LOGIN_BUTTON_COOLDOWN";

const Login = (props) => {
  const navigate = useNavigate();
  const passwordField = useRef();
  const passwordIcon = useRef();
  const dispatch = useDispatch();
  const { loading, user, tempToken, otpSending } = useSelector(
    (state) => state.app
  );
  const [remainingTime, setRemainingTime] = useState(0);
  const [countdownText, setCountdownText] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const countdownIntervalRef = useRef(null);

  useEffect(() => {
    //*Throw the user to post-login screen if user state is not null.
    if (tempToken) {
      navigate("/verifyOtp");
    }
  }, [tempToken]);

  const toggleVisibility = () => {
    if (passwordField.current.type === "password") {
      passwordField.current.type = "text";
      passwordIcon.current.src = eyeclose;
    } else {
      passwordField.current.type = "password";
      passwordIcon.current.src = eyeopen;
    }
  };

  const handleSubmit = async (form) => {
    form.preventDefault();

    const formData = new FormData(form.target);
    const data = formDataHelper(formData);

    // Basic validation
    if (!data?.username) {
      notify("Email is required", "info");
      return;
    } else if (!data?.password) {
      notify("Password is required", "info");
      return;
    }

    try {
      const result = await dispatch(sendOtpLogic(data)).unwrap();
      if (result?.retry_after) {
        const seconds = parseInt(result.retry_after, 10);
        if (!isNaN(seconds)) {
          startCountdown(seconds + 5); // Add 5s buffer
        }
      }

      localStorage.setItem("lastTime", 120); // Optional usage
    } catch (err) {
      console.error("Unexpected error:", err);
      notify("Unexpected error occurred", "info");
    }
  };

  const startCountdown = (seconds) => {
    const endTime = Math.floor(Date.now() / 1000) + seconds;
    localStorage.setItem(COOLDOWN_KEY, JSON.stringify({ endTime }));

    setRemainingTime(seconds);
    setIsButtonDisabled(true);

    countdownIntervalRef.current = setInterval(() => {
      setRemainingTime((prev) => {
        if (prev <= 1) {
          clearInterval(countdownIntervalRef.current);
          localStorage.removeItem(COOLDOWN_KEY);
          setIsButtonDisabled(false);
          setCountdownText("");
          return 0;
        }

        const newTime = prev - 1;
        const hours = Math.floor(newTime / 3600);
        const minutes = Math.floor((newTime % 3600) / 60);
        const seconds = newTime % 60;

        let text = "Try again in ";
        if (hours) text += `${hours}h `;
        if (minutes || hours) text += `${minutes}m `;
        text += `${seconds}s`;

        setCountdownText(text.trim());
        return newTime;
      });
    }, 1000);
  };

  // Check existing cooldown on mount
  useEffect(() => {
    const checkCooldown = async () => {
      const stored = localStorage.getItem(COOLDOWN_KEY);
      if (stored) {
        const { endTime } = JSON.parse(stored);
        const now = Math.floor(Date.now() / 1000);
        const remaining = endTime - now;
        if (remaining > 0) {
          startCountdown(remaining);
        } else {
          localStorage.removeItem(COOLDOWN_KEY);
        }
      }
    };
    checkCooldown();

    return () => clearInterval(countdownIntervalRef.current);
  }, []);
  
  return (
    <section className="container-fluid loginBG">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Welcome to Precise Digital</title>
        <link rel="canonical" href={window.location.origin} />
      </Helmet>
      <div
        className="col-sm-12 col-lg-10 col-md-10"
        style={{ margin: "0 auto" }}
      >
        <div className="row p-5">
          <div className="col-sm-12 col-lg-6 col-md-6">
            <div className="container text-center">
              <img
                src={LoginImage}
                alt="Welcome to Rose Health"
                className="img-fluid"
                style={{ height: "90vh" }}
              />
            </div>
          </div>
          <div className="col-sm-12 col-lg-6 col-md-6">
            <CardLayout
              className="container col-sm-12 col-md-8 col-lg-8"
              style={{ marginTop: "5%" }}
            >
              <div className="text-center container-fluid py-3">
                <img
                  className={
                    process.env.REACT_APP_DASHBOARD_TYPE === "adult"
                      ? "pt-3"
                      : ""
                  }
                  src={
                    process.env.REACT_APP_DASHBOARD_TYPE === "adult"
                      ? AdultLoginLogo
                      : YouthLoginLogo
                  }
                  height="65%"
                  width="65%"
                  alt="Rose Health"
                />
                <div
                  className={` container ${
                    process.env.REACT_APP_DASHBOARD_TYPE === "adult"
                      ? "pt-5"
                      : "pt-1"
                  } `}
                >
                  <h4 className="primary-text">Welcome Again!</h4>
                  <span className="secondary-text">
                    Sign in to your Precise Account
                  </span>
                </div>
              </div>
              <form className="container" onSubmit={handleSubmit}>
                <div className="form-group pb-3">
                  <label>
                    {" "}
                    <strong>Email Address</strong>
                  </label>
                  <input
                    autoFocus
                    name="username"
                    id="username"
                    placeholder="Enter Email Address"
                  />
                </div>

                <div className="form-group pb-3">
                  <label>
                    {" "}
                    <strong>Your Password</strong>
                  </label>
                  <div style={{ position: "relative" }}>
                    <input
                      type="password"
                      name="password"
                      id="password"
                      placeholder="Enter Your Password"
                      ref={passwordField}
                    />
                    <img
                      src={eyeopen}
                      ref={passwordIcon}
                      onClick={toggleVisibility}
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        cursor: "pointer",
                      }}
                      alt="Show Password"
                      height="25px"
                      width="25px"
                    />
                  </div>
                </div>
                <div className="container-fluid d-flex justify-content-end">
                  <Link to="/reset">Forgot Password</Link>
                </div>
                <br />
                <div className="container-fluid text-center py-4">
                  <button
                    type="submit"
                    // disabled={otpSending || isButtonDisabled}
                    className="primary-btn"
                    style={{ width: "100%" }}
                  >
                    Login
                  </button>
                </div>

                {isButtonDisabled && (
                  <div className="flex text-center justify-center">
                    <span className="block text-center text-sm text-red-500 mt-2">
                      {countdownText}
                    </span>
                  </div>
                )}

                <div className="container-fluid text-center py-3">
                  <span>Don't have a Precise account yet?</span>
                  <br />
                  <span>
                    <Link
                      to="https://rosehealth.com/schedule.html"
                      target="_blank"
                      rel="noopener noreferer"
                    >
                      Schedule a demo
                    </Link>{" "}
                    to get started
                  </span>
                </div>
              </form>
            </CardLayout>
          </div>
        </div>
      </div>
      <Outlet />
    </section>
  );
};

export default Login;
